import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';

import Registration from '../pages/Registration.vue';
import ResetPassword from '../pages/ResetPassword.vue';
import PersonalData from '../pages/PersonalData.vue';
import PersonalDataBack from '../pages/PersonalDataBack26.vue';
import UsersList from '../pages/UsersList.vue';
import RegisterFinish from '../pages/RegisterFinish.vue';
import NewLogin from '../pages/NewLogin.vue';
import Page404 from '../pages/404.vue';
import VerifyUser from '../pages/VerifyUser.vue'
import Policy from '../pages/Policy.vue'
import Dashboard from '../pages/Dashboard.vue';
import Users from '../pages/Users.vue'

import NotFoundPage from '../components/Common/NotFoundPage.vue';

import { AUTH_URL } from '../../vars';

Vue.use(VueRouter);
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: NewLogin,
    meta: { title: 'Вход' },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {title: 'Регистрация' },
  },
  {
    path: '/',
    name: 'PersonalData',
    component: PersonalData,
    meta: { requiresAuth: true, title: 'Личный кабинет' },
  },
  {
    path: '/expired_reg_J4gE5d',
    name: 'PersonalDataBack',
    component: PersonalDataBack,
    meta: { requiresAuth: true, title: 'Личный кабинет' },
  },
  {
    path: '/users-list',
    name: 'UsersList',
    component: UsersList,
    meta: { requiresAuth: false,  title: 'Участники' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: false,  title: 'Dashboard' },
  },
  {
    path: '/register-finish/:email',
    name: 'RegisterFinish',
    component: RegisterFinish,
    props: true,
  },
  {
    path: '/privacy',
    name: 'Policy',
    component: Policy,
    meta: { requiresAuth: true, title: 'Политика в отношении обработки персональных данных' },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { title: 'Восстановление пароля' },
  },
  {
    path: '/not-found',
    name: 'NotFoundPage',
    component: NotFoundPage,
    meta: { title: 'Страница не найдена' },
  },
  {
    path: '/personal-data',
    name: 'PersonalData',
    component: PersonalData,
    meta: { requiresAuth: true, title: 'Личный кабинет' },
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, title: 'Справочник Users' },
  },
  {
    path: '/verify-user',
    name: 'VerifyUser',
    component: VerifyUser
  },
  {
    path: '/404',
    name: '404',
    component: Page404
  },
  {
    path: '*',
    redirect: '/404'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});
const DEFAULT_TITLE = 'KCSNR User Portal';
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  // console.log(from);
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = 'https://genom.kcsni-service.ru/media/static/favicon.ico';
    document.getElementsByTagName('head')[0].appendChild(link);
  });
});
router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      const auth = await axios.get(`${AUTH_URL}profile/`, {
        headers: {
          Authorization: `Token ${localStorage.token}`,
        },
      });

      if (!auth) {
        next({
          path: '/login',
        });
      } else {
        next();
      }
    } else {
      next();
    }
  } catch (ex) {

    next();
    if (router.history.current.fullPath != '/login'){
      next({
        path: '/login',
      });
    }

  }
});

export default router;
